const env = 'dev';

const firebaseConfig = {
            apiKey: "AIzaSyD3XVoM8aMxEGXBlQ6Lk-wq25vBfREYFqU",
            authDomain: "cuadraladev.firebaseapp.com",
            databaseURL: "https://cuadraladev.firebaseio.com",
            storageBucket: "cuadraladev.appspot.com",
            messagingSenderId: "877528948266"
};

const firebaseConfigDev = {
            apiKey: "AIzaSyD3XVoM8aMxEGXBlQ6Lk-wq25vBfREYFqU",
            authDomain: "cuadraladev.firebaseapp.com",
            databaseURL: "https://cuadraladev.firebaseio.com",
            storageBucket: "cuadraladev.appspot.com",
            messagingSenderId: "877528948266"
};

exports.firebaseConfig = (env==='dev' ? firebaseConfigDev : firebaseConfig);


// WEBPACK FOOTER //
// ./src/lib/firebase/config.js